import React from "react"
import styled from "styled-components"
import { animated, useTransition } from "@react-spring/web"
import DragIcon from "./UI_ClickDrag-01.svg"
import ContainerImage from "./UI_ClickAndDrag_ToolTip_Container.png"

export default function DragTooltipDesktop({ isVisible = true }) {
  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(0%,2rem,0)" },
    enter: { opacity: 1, transform: "translate3d(0%,0%,0)" },
    leave: { opacity: 0, transform: "translate3d(0%,2rem,0)" },
    delay: 500,
    config: {
      duration: 800
    }
  })

  return transition(
    (styles, item) =>
      item && (
        <TipWraper style={{ ...styles }}>
          <TipHolder>
            <StyledImg src={DragIcon} alt="" />
            <StyledP>
              Click and drag
              <br />
              or scroll mouse to move it
            </StyledP>
          </TipHolder>
        </TipWraper>
      )
  )
}

const TipWraper = styled(animated.div)`
  position: relative;
`

const TipHolder = styled(animated.div)`
  padding-top: 1rem;
  background-image: url(${ContainerImage});
  background-size: 100% auto;
  background-repeat: no-repeat;
  height: 5rem;
  width: 18rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const StyledImg = styled(animated.img)`
  width: 2.7rem;
  margin: 0 1rem;
`

const StyledP = styled(animated.p)`
  color: white;
  width: 100%;
  line-height: 1.2;
`
